module.exports = __webpack_public_path__ + "static/media/background-latinhas.cabc9d4c.png";